/*jshint esversion:6*/
import classes from "dom-classes";

export const animationEnd =
  "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend";
export const transitionEnd =
  "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend";

export function MatchHeight(parents /*Expects array*/) {
  Array.prototype.forEach.call(parents, function (el) {
    if (el.childElementCount != 2) return;
    const children = el.children;
    children[0].style.height = "initial";
    children[1].style.height = "initial";

    if (children[0].offsetHeight > children[1].offsetHeight) {
      children[1].style.height = `${children[0].offsetHeight}px`;
      return;
    }
    children[0].style.height = `${children[1].offsetHeight}px`;
  });
}

export const browser = {
  isIe: function () {
    return navigator.appVersion.indexOf("MSIE") != -1;
  },
  navigator: navigator.appVersion,
  getVersion: function () {
    var version = 999; // we assume a sane browser
    if (navigator.appVersion.indexOf("MSIE") != -1)
      // bah, IE again, lets downgrade version number
      version = parseFloat(navigator.appVersion.split("MSIE")[1]);
    return version;
  },
};

export function isIE9() {
  return browser.isIe() && browser.getVersion() <= 9;
}

/**
 * @param  {Object} mask-image element
 */
export function LoadMaskImage(maskContainer, callback = null) {
  classes.add(maskContainer, "loading");

  setTimeout(function () {
    const image = document.createElement("img");
    const maskPlaceholder =
      maskContainer.getElementsByClassName("mask--placeholder");
    image.src = maskContainer
      .getElementsByClassName("mask--image-mask")[0]
      .getAttribute("data-image");

    const imageWidth = maskPlaceholder.length
      ? maskPlaceholder[0].getAttribute("data-image-width")
      : null;

    classes.add(image, "mask--image");
    image.onload = function () {
      if (classes.has(maskContainer, "mask-image--background")) {
        const imageBG = document.createElement("div");
        classes.add(imageBG, "mask--image");
        imageBG.style.backgroundImage = `url(${image.src})`;

        if (imageWidth) {
          imageBG.style.width = `${imageWidth}%`;
        }

        maskContainer.appendChild(imageBG);
      } else {
        if (imageWidth) {
          image.style.width = `${imageWidth}%`;
        }
        maskContainer.appendChild(image);
      }
      classes.add(maskContainer, "loaded");
      if (callback) callback();
    };
  }, 1000);
}

export function animateChildren(parentEL) {
  parentEL.style.opacity = 1;
  classes.add(parentEL, "initialized");
  const children = Array.prototype.slice.call(parentEL.children || [], 0);
  let delay = 0;

  children.forEach((child) => {
    classes.add(child, "animate-ready");
    setTimeout(() => classes.add(child, "animate"), (delay += 100));
  });
}

export function getDistance(sideA, sideB) {
  return Math.sqrt(Math.pow(sideB - sideA, 2));
}

export function requestFrame(callback, delay) {
  var dateNow = Date.now,
    requestAnimation = window.requestAnimationFrame,
    start = dateNow(),
    stop,
    intervalFunc = function () {
      dateNow() - start < delay || ((start += delay), callback());
      stop || requestAnimation(intervalFunc);
    };
  requestAnimation(intervalFunc);
  return {
    clear: function () {
      stop = 1;
    },
  };
}

export function makeLabel($feilds) {
  $feilds.each((index, feild) => {
    if (feild.value) {
      $(feild).closest(".element").addClass("move-label");
    }
    $(feild)
      .on("focus", (e) => {
        $(e.currentTarget).closest(".element").addClass("move-label");
      })
      .on("blur", (e) => {
        if (e.currentTarget.value) return;
        $(e.currentTarget).closest(".element").removeClass("move-label");
      });
  });
}

export function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

export function detectBrowser() {
  if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
    $("body").addClass("ios-device");
  }
  if (navigator.userAgent.match(/Android/i)) {
    $("body").addClass("android-device");
  }

  //detect desktop platform
  if (navigator.appVersion.indexOf("Win") != -1) {
    $("body").addClass("win-os");
  }
  if (navigator.appVersion.indexOf("Mac") != -1) {
    $("body").addClass("mac-os");
  }

  //detect IE 10 and above 11
  if (
    navigator.userAgent.indexOf("MSIE") !== -1 ||
    navigator.appVersion.indexOf("Trident/") > 0
  ) {
    $("html").addClass("ie10");
  }
}

export const mapStyles = [
  {
    featureType: "all",
    elementType: "labels.text.fill",
    stylers: [
      {
        saturation: 36,
      },
      {
        color: "#000000",
      },
      {
        lightness: 40,
      },
    ],
  },
  {
    featureType: "all",
    elementType: "labels.text.stroke",
    stylers: [
      {
        visibility: "on",
      },
      {
        color: "#000000",
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    featureType: "all",
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#000000",
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#000000",
      },
      {
        lightness: 17,
      },
      {
        weight: 1.2,
      },
    ],
  },
  {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [
      {
        color: "#000000",
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [
      {
        color: "#000000",
      },
      {
        lightness: 21,
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#000000",
      },
      {
        lightness: 17,
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#000000",
      },
      {
        lightness: 29,
      },
      {
        weight: 0.2,
      },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [
      {
        color: "#000000",
      },
      {
        lightness: 18,
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [
      {
        color: "#000000",
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [
      {
        color: "#000000",
      },
      {
        lightness: 19,
      },
    ],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        color: "#000000",
      },
      {
        lightness: 17,
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./app/components/helpers.js